import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-forgot-password-new',
  templateUrl: './forgot-password-new.component.html',
  styleUrls: ['./forgot-password-new.component.scss']
})
export class ForgotPasswordNewComponent implements OnInit {

  forget_form: FormGroup;
  submitted = false
  constructor(private _fromBuilder: FormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private notifier: NotifierService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.forget_form = this._fromBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(values) {
    this.submitted = true
    this.forget_form.markAllAsTouched();
    if (this.forget_form.invalid) {
      this.notifier.notify('warning','Please enter valid email address')
      return;
    }
    this.spinner.show()
    this.authService.forgotPassword(values.email).subscribe(res => {
      this.spinner.hide()
      if (res['status']) {
        this.notifier.notify('success', res['message'])
        setTimeout(() => {
          this.router.navigateByUrl('/login')
        }, 2000);
      } else {
        this.notifier.notify('danger', res['message'])
      }
    })
  }

  validation_messages = {
    'email': [
      { type: 'email', message: 'Email format must be similar to joe@abc.com' },
      { type: 'required', message: 'Please enter email address' },
    ],
  }

  get f() {
    return this.forget_form.controls
  }

  login() {
    this.router.navigateByUrl('/login')
  }

}
